/** biome-ignore-all lint/complexity/noStaticOnlyClass: No other way to do it*/

import {
	BlogPostUmbPageContentModelContentType,
	BlogStartUmbPageContentModelContentType,
	Error404UmbPageContentModelContentType,
	EventListingUmbPageContentModelContentType,
	EventUmbPageContentModelContentType,
	FlexibleUmbPageContentModelContentType,
	FolderUmbPageContentModelContentType,
	LoginUmbPageContentModelContentType,
	NewsListingUmbPageContentModelContentType,
	NewsUmbPageContentModelContentType,
	RestrictedAccessUmbPageContentModelContentType,
	SearchUmbPageContentModelContentType,
	StandardUmbPageContentModelContentType,
	StartUmbPageContentModelContentType,
} from "#/_generated/umbraco/delivery-api/models";

export class ContentTypes {
	static BlogPostPage = BlogPostUmbPageContentModelContentType.blogPostUmbPage;
	static BlogStartPage =
		BlogStartUmbPageContentModelContentType.blogStartUmbPage;

	static Error404Page = Error404UmbPageContentModelContentType.error404UmbPage;
	static EventPage = EventUmbPageContentModelContentType.eventUmbPage;
	static EventListingPage =
		EventListingUmbPageContentModelContentType.eventListingUmbPage;
	static FlexiblePage = FlexibleUmbPageContentModelContentType.flexibleUmbPage;
	static FolderUmbPage = FolderUmbPageContentModelContentType.folderUmbPage;

	static NewsListingPage =
		NewsListingUmbPageContentModelContentType.newsListingUmbPage;
	static NewsPage = NewsUmbPageContentModelContentType.newsUmbPage;

	static RestrictedAccessPage =
		RestrictedAccessUmbPageContentModelContentType.restrictedAccessUmbPage;
	static SearchPage = SearchUmbPageContentModelContentType.searchUmbPage;

	static StandardPage = StandardUmbPageContentModelContentType.standardUmbPage;
	static StartPage = StartUmbPageContentModelContentType.startUmbPage;
	static LoginPage = LoginUmbPageContentModelContentType.loginUmbPage;
}
